import WhatsNew from './WhatsNew';

export default WhatsNew;